import React, { useEffect } from "react";
import * as S from "./index-styled";
import { Col, Row } from "reactstrap";
import PT from "prop-types";
import Aside from "./Aside/container";
import MobileNav from "./MobileNav/container";
import isempty from "lodash/isEmpty";
import Seo from "./Seo";
import MastersList from "./Master/List";
import CloseMapBtn from "./CloseMapBtn";
import { useTranslation } from "react-i18next";
import SeoText from "./SeoText";
import { SEARCH_NS as ns } from "@/i18n/ns";
import { useExtractHL } from "@/hooks/useExtractHL";
import EmptyResults from "./EmptyResults";
import { useParams } from "react-router-dom";
import { FullScreenSpin } from "_c/preloader";
import Filters from "./Filters";
import { useParsedQuery } from "@/hooks/useParsedQuery";
import InlineFilters from "./InlineFilters";
import Scroller from "./Scroller";
import FiltersLoadable from "./Filters/loadable";
import MasterPageLoadable from "_p/master/loadable";
import Loader from "./Loader";
import ScrollFab from "./ScrollFab";
import { usePreloadModules } from "@/hooks/usePreloadModules";
import { useIsMobile } from "@/hooks/useIsMobile";

const seoDefaultsNs = ns + ":seo_defaults.";
const preloadModules = [FiltersLoadable, MasterPageLoadable];

const SearchPage = (props) => {
  const { t, ready } = useTranslation(["common", "errors", ns], {
    useSuspense: false,
  });
  usePreloadModules({ modules: preloadModules, delay: 1500 });
  const query = useParsedQuery();
  const params = useParams();
  const hl = useExtractHL();
  const isMobile = useIsMobile();
  useEffect(() => {
    return () => props.resetLocMeta();
  }, []);
  // https://trello.com/c/CJ0S8kRN
  const isPageNoIndex = props.isPageNoIndex || !!query.id;
  if (!ready) return <FullScreenSpin size="xl" />;
  return (
    <>
      <Seo
        noIndex={isPageNoIndex}
        canonicalUrl={props.seo.canonical_url}
        desc={props.seo.desc || t(seoDefaultsNs + "desc")}
        title={props.seo.title || t(seoDefaultsNs + "title")}
      />
      <Filters t={t} params={params} query={query} />
      {isMobile && <MobileNav t={t} />}
      {props.isMapOpen && isMobile && (
        <CloseMapBtn toggleMap={props.toggleMap} />
      )}
      <S.ContentContainer>
        <Row>
          <Scroller />
        </Row>
        <Row>
          <Col>
            <InlineFilters params={params} query={query} t={t} />
          </Col>
        </Row>
        <Row>
          <S.LeftCol id="search-content-col" lg="7">
            {!props.loading && isempty(props.results) && (
              <EmptyResults params={params} t={t} query={query} hl={hl} />
            )}
            {!isempty(props.results) && (
              <S.MasterContainer>
                <MastersList
                  hl={hl}
                  t={t}
                  masters={props.results}
                  openMapPopup={props.openMapPopup}
                />
              </S.MasterContainer>
            )}
            <Loader query={query} params={params} />
          </S.LeftCol>
          <S.RightCol id="search-sidebar-container" lg="5">
            <Aside params={params} isMobile={isMobile} t={t} query={query} />
          </S.RightCol>
        </Row>
        <div
          id="search-sticky-boundary"
          css={`
            height: 5px;
          `}
        />
        <SeoText
          title={props.seo.title_h1 || t(seoDefaultsNs + "h1")}
          desc={props.seo.text || t(seoDefaultsNs + "text")}
        />
        <ScrollFab />
      </S.ContentContainer>
    </>
  );
};
SearchPage.propTypes = {
  loading: PT.bool,
  isMapOpen: PT.bool,
  hasMore: PT.bool,
  isPageNoIndex: PT.bool,

  toggleMap: PT.func,
  openMapPopup: PT.func,
};

export default SearchPage;
